export default "__VITE_ASSET__Dffp8fQ0__"